export const routes = {
  contact_us: "/contact-us",
  training_form:"/training-form"
};
